module.exports = __webpack_public_path__ + "static/media/deliveryVan_salmon.b8a1dc56.svg";